import { render } from "./MasterTabs.vue?vue&type=template&id=c901f216&scoped=true"
import script from "./MasterTabs.vue?vue&type=script&lang=js"
export * from "./MasterTabs.vue?vue&type=script&lang=js"

import "./MasterTabs.vue?vue&type=style&index=0&id=c901f216&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c901f216"]])

export default __exports__